<!DOCTYPE html>
<ion-content>
  <div class="background-wrap">
    <div class="img-wrapper">
      <div class="offer-wrapper-content">
        <div class="top-text">
          <h2>{{ "check-winnings.surprise" | translate }} {{creditAmountDvString}}
            {{ "check-winnings.credit" | translate }}</h2>
          <p>{{ "check-winnings.top_subtext" | translate }}</p>
        </div>
        <ng-lottie class="credit-animation" [options]="{ path: './../../../assets/spine_animation/credit-animation.json' , loop : false}" (animationCreated)="animationInitiate()">
        </ng-lottie>
        <div class="bottom-text common-margin">
          <h3 class="common-heading ">
            <span class="yellow-text">{{creditAmountDvString}} {{ "check-winnings.yellow_text" | translate }}</span>
          </h3>
          <div class="join-syndicate-description">{{ "check-winnings.description_one" | translate }} <br>
            <span>{{ "check-winnings.description_two" | translate }}</span></div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
